import React from 'react';
import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { PageTitle } from 'components/PageTitle';
import { Header, HeaderTitle } from 'components/Header';
import { PollsList } from './components/PollsList';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { Link } from 'react-router-dom';
import { TotadminPermission } from 'data/__generated__';

export const Polls = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.polls} />
                </HeaderTitle>
                <ButtonsContainer>
                    <Link to="/poll/create">
                        <TotemPrimaryButton requiredPermissions={[TotadminPermission.PollsManage]}>
                            Créer un sondage
                        </TotemPrimaryButton>
                    </Link>
                </ButtonsContainer>
            </Header>
            <Content>
                <PollsList />
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;
